import React from 'react';
import { RiArrowRightCircleFill, RiArrowLeftCircleFill } from 'react-icons/ri';

interface Props {
  nextImage: () => void;
  prevImage: () => void
}
const Arrow = ({ prevImage, nextImage }: Props) => (
  <>
    <RiArrowLeftCircleFill
      onClick={prevImage}
      color="black"
      size="1.5rem"
      style={{ cursor: 'pointer' }}
    />
    <RiArrowRightCircleFill
      onClick={nextImage}
      color="black"
      size="1.5rem"
      style={{ cursor: 'pointer' }}
    />
  </>
);

export default Arrow;
